const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TRANSFER_PASSWORD_REQUIRED = "This transfer is password protected";
export const TRANSFER_INCORRECT_PASSWORD = "Incorrect password";

export const isTransferPasswordRequired = (detail) =>
  detail === TRANSFER_PASSWORD_REQUIRED;

export const isTransferIncorrectPassword = (detail) =>
  detail === TRANSFER_INCORRECT_PASSWORD;

const withPasswordQuery = (url, password) => {
  if (!password) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}password=${encodeURIComponent(password)}`;
};

export const transferFileDownloadUrl = (token, fileId, password = null) =>
  withPasswordQuery(`${API}/transfers/${token}/files/${fileId}`, password);

export const transferDownloadAllUrl = (token, password = null) =>
  withPasswordQuery(`${API}/transfers/${token}/download-all`, password);

export async function fetchPublicTransfer(token, password = null) {
  const headers = password ? { "X-Transfer-Password": password } : {};
  const res = await fetch(`${API}/transfers/${token}`, { headers });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.detail || "Request failed");
    err.status = res.status;
    err.detail = body?.detail;
    throw err;
  }
  return body;
}
